import React from 'react';

import Add from '@r1-frontend/ui-react/components/svg/main/Add';
import Minus from '@r1-frontend/ui-react/components/svg/main/Minus';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { EStepperSizes } from './index';

import { Control, Wrapper } from './styled';

export type StepperProps = {
    value: number,
    min?: number,
    max?: number,

    summaryLimitsReached?: boolean, // using when need disable an increment by a global page limitations;

    onIncrement: () => void,
    onDecrement: () => void,

    disabled?: boolean,

    $size?: keyof typeof EStepperSizes, // by default 'medium'
    $bgColor?: COLORS, // by default is COLORS.TextWhite
    $color?: COLORS, // by default is COLORS.TextPrimary
};

/**
 * Stepper component
 * Displayed two control element (increment/decrement) with value
 *
 * @link https://www.figma.com/file/dZ9nsGKTEkHJJGcfuP8pRi/%F0%9F%8D%8FDS-WEB?type=design&node-id=163-903&t=Gh83vNM2PFzzDZ4n-0
 */
const Stepper = ({
    value = 1,
    min = 1,
    max = 999999,

    summaryLimitsReached = false,

    disabled = false,

    onIncrement,
    onDecrement,

    ...props
}: StepperProps): JSX.Element => {
    return (
        <div {...props} data-test={'Stepper'} data-disabled={disabled}>
            <Wrapper>
                <Control
                    onClick={onDecrement}
                    $transparency={value <= min}
                    data-test={'Stepper-decrement'}
                >
                    <Minus size={20}/>
                </Control>
                <div data-test={'Stepper-value'}>{value}</div>
                <Control
                    onClick={onIncrement}
                    $transparency={summaryLimitsReached || value >= max}
                    data-test={'Stepper-increment'}
                >
                    <Add size={20}/>
                </Control>
            </Wrapper>
        </div>
    );
};

export default Stepper;
